import * as React from 'react';
import Box from '@mui/material/Box';
import { useState } from 'react';
import classes from "./Operations.module.scss";
import OperationGroup from './OperationGroup';
import RefreshIcon from '@mui/icons-material/Refresh';
import ImportFileTab from './Elements/ImportFile';
import ExportFileTab from './Elements/ExportFile';
import ContextSyncTab from './Elements/ContextSync';
import CreateClusterBox from './Elements/CreateCluster';
import { ReactComponent as ImportIcon } from "../../assets/Import.svg";
import { ReactComponent as ExportIcon } from "../../assets/Export.svg";
import { ReactComponent as SyncIcon } from "../../assets/Sync.svg";
import { Typography } from '@mui/material';
import { fetchImportFiles } from 'store';
import { useDispatch } from 'react-redux';
import { fetchClusterData } from 'store';
import WorkbenchUploadBox from './Elements/WorkbenchUpload';
import ImportKnowledgeBaseBox from './Elements/ImportKnowledgeBase';
import { fetchRAGFiles } from 'store';

function Operations() {

  const [chatExpanded, setChatExpanded] = useState(true);
  const [activeTab, setActiveTab] = useState(1);
  const dispatch = useDispatch();

  const handleImportFileData = () => {
    dispatch(fetchImportFiles());
  };

  const handleRagFileData = () => {
    dispatch(fetchRAGFiles());
  }

  const handleExportFileData = () => {
    dispatch(fetchClusterData());
  };

  const clearCacheAndFetchData = async () => {
    try {
      await Promise.all([dispatch(fetchClusterData())]);
    } catch (error) {
      console.error("Error clearing cache and fetching data:", error);
    }
  };

  return (
    <Box className={classes.mainSection}>
      <Box component="section" className={chatExpanded ? classes.chatGridExpanded : classes.chatGrid} >
        <section className={classes.headline}>
          <Typography className={classes.title}>Audience Assistant</Typography>
        </section>
        <Box className={classes.sectionGroup}>
          <OperationGroup
            title="Import"
            lable="Import Cluster Output"
            onClick={() => {
              handleImportFileData();
              setChatExpanded(!chatExpanded);
              setActiveTab(1);
            }}
            endIcon={<ImportIcon className={classes.endIconStyle}  />}
            buttonText="Click to Import"
            disabled={!chatExpanded}
          />
             <div className={classes.divider}></div>
          <OperationGroup
            title="Knowledge Base Overview"
            lable="Manage Knowledge Base Source"
            onClick={() => {
              handleRagFileData();
              setChatExpanded(!chatExpanded);
              setActiveTab(6);
            }}
            endIcon={<ImportIcon className={classes.endIconStyle}  />}
            buttonText="Manage"
            disabled={!chatExpanded}
          />
          <div className={classes.divider}></div>
          <OperationGroup
            title="Export"
            lable="Export Application Output"
            onClick={() => {
              handleImportFileData();
              handleExportFileData();
              setChatExpanded(!chatExpanded);
              setActiveTab(2);
            }}
            endIcon={<ExportIcon className={classes.endIconStyle}  />}
            buttonText="Click to Export"
            disabled={!chatExpanded}
          />
          <div className={classes.divider}></div>
          <OperationGroup
            title="Create Cluster"
            lable="Develop Cluster Groupings"
            onClick={() => {
              handleImportFileData();
              clearCacheAndFetchData();
              setChatExpanded(!chatExpanded);
              setActiveTab(3);
            }}
            endIcon={<RefreshIcon className={classes.endIconStyle}  /> }
            buttonText="Click to Run"
            disabled={!chatExpanded}
          />
        </Box>
        <section className={classes.headline}>
          <Typography className={classes.title}>Data Workbench</Typography>
        </section>
        <Box className={classes.sectionGroup}>
          <OperationGroup
            title="Context Sync"
            lable="Sync Context Files"
            onClick={() => {
              setChatExpanded(!chatExpanded);
              setActiveTab(4);
            }}
            endIcon={<SyncIcon className={classes.endIconStyle}  />}
            buttonText="Click to Sync"
            disabled={!chatExpanded}
          />
          <div className={classes.divider}></div>
          <OperationGroup
            title="Upload"
            lable="Upload Workbench Data"
            onClick={() => {
              setChatExpanded(!chatExpanded);
              setActiveTab(5);
            }}
            endIcon={<SyncIcon className={classes.endIconStyle}  />}
            buttonText="Click to Upload"
            disabled={!chatExpanded}
          />
        </Box>
      </Box>

      <Box component="section" className={chatExpanded ? classes.graphGridHidden : classes.graphGrid}>
        {activeTab === 1 && <ImportFileTab onCancel={() => {
          setChatExpanded(true);
          setActiveTab(1);
        }} />}
        {activeTab === 2 && <ExportFileTab onCancel={() => {
          setChatExpanded(true);
          setActiveTab(1);
        }} />}
         {activeTab === 3 && <CreateClusterBox onCancel={() => {
          setChatExpanded(true);
          setActiveTab(1);
        }} />}
        {activeTab === 4 && <ContextSyncTab onCancel={() => {
          setChatExpanded(true);
          setActiveTab(1);
        }} />}
        {activeTab === 5 && <WorkbenchUploadBox onCancel={() => {
          setChatExpanded(true);
          setActiveTab(1);
        }} />}
        {activeTab === 6 && <ImportKnowledgeBaseBox onCancel={() => {
          setChatExpanded(true);
          setActiveTab(1);
        }} />}
      </Box>
    </Box>
  );
}

export default Operations;
